import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("tm_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  // Phase 3A — Owner cross-user read-only view: auto-inject user_id filter on
  // GET requests when the owner is viewing another trader. The backend enforces
  // read-only via services/permissions.py; this is purely a convenience so
  // callers don't need to know about the view-as feature.
  const viewAs = localStorage.getItem("tm_view_as_user_id");
  if (viewAs && cfg.method?.toLowerCase() === "get") {
    cfg.params = { ...(cfg.params || {}), user_id: viewAs };
  }
  // Execution-source scoping — every analytics GET carries the currently
  // selected source unless the caller explicitly passed one.
  const execSource = localStorage.getItem("tm_execution_source");
  if (execSource && cfg.method?.toLowerCase() === "get") {
    const p = cfg.params || {};
    if (!("execution_source" in p)) {
      cfg.params = { ...p, execution_source: execSource };
    }
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err.config.url?.includes("/auth/")) {
      localStorage.removeItem("tm_token");
      localStorage.removeItem("tm_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
